import { TAB_FULL_WIDTH } from 'theme/constants';

export const baseInfoWrapperStyle = {
  ['@media (min-width: 1440px)']: {
    width: 1272,
  },

  ['@media (max-width: 1440px)']: {
    width: TAB_FULL_WIDTH,
  },
};
